/*
 * COZY: cart drawer free shipping progress bar.
 *
 * The bar itself is rendered server side by snippets/cozy-free-shipping-bar.liquid,
 * so the numbers are always Shopify's, never calculated in the browser. This file
 * only handles the two things Liquid cannot do: animating the fill to its target
 * width, and firing the celebration at the moment the cart crosses the threshold.
 *
 * Crossing detection uses window.cozyFreeShippingQualified, which survives the
 * cart drawer being re-rendered (both CartDrawer.renderContents and
 * CartDrawerItems replace innerHTML, which destroys and recreates this element).
 * On the very first connect of a page load the flag is undefined, so no
 * celebration fires for a cart that already qualified before the page opened.
 */
if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.fill = this.querySelector('.cozy-ship__fill');
        this.confetti = this.querySelector('.cozy-ship__confetti');

        const percent = Math.max(0, Math.min(100, parseFloat(this.dataset.percent) || 0));
        const qualified = this.dataset.qualified === 'true';
        const previouslyQualified = window.cozyFreeShippingQualified;

        // Animate from 0 to the server rendered percentage.
        if (this.fill) {
          requestAnimationFrame(() => {
            this.fill.style.width = `${percent}%`;
          });
        }

        // Only celebrate on a genuine false to true crossing.
        if (qualified && previouslyQualified === false) this.celebrate();

        window.cozyFreeShippingQualified = qualified;
      }

      celebrate() {
        if (!this.confetti) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Wait for the drawer open transition so the burst is actually seen.
        setTimeout(() => {
          this.classList.add('is-celebrating');
          this.burst();
        }, 450);

        setTimeout(() => this.classList.remove('is-celebrating'), 1900);
      }

      burst() {
        const colors = ['#1f6f5c', '#c9a227', '#0f0f0f', '#e8e0d4'];
        const pieceCount = 22;

        for (let i = 0; i < pieceCount; i++) {
          const piece = document.createElement('span');
          piece.className = 'cozy-ship__confetti-piece';
          piece.style.left = `${8 + Math.random() * 84}%`;
          piece.style.backgroundColor = colors[i % colors.length];
          piece.style.setProperty('--cozy-x', `${(Math.random() * 80 - 40).toFixed(0)}px`);
          piece.style.setProperty('--cozy-y', `-${(40 + Math.random() * 55).toFixed(0)}px`);
          piece.style.setProperty('--cozy-rotate', `${(Math.random() * 540 - 270).toFixed(0)}deg`);
          piece.style.setProperty('--cozy-delay', `${(Math.random() * 180).toFixed(0)}ms`);
          piece.style.setProperty('--cozy-duration', `${(900 + Math.random() * 500).toFixed(0)}ms`);

          this.confetti.appendChild(piece);
          setTimeout(() => piece.remove(), 2400);
        }
      }
    }
  );
}
